LibCookieConsent.init()

application.register("part_cookieconsent", class extends Stimulus.Controller {
    connect() {
        const selector = this.element;

        if (document.querySelector('.part_form_cookieconsent') !== null || selector === null) {
            return
        }

        if (localStorage.getItem('lib-cookieconsent') === null || parseInt(localStorage.getItem('lib-cookieconsent-expire')) < Date.now()) {
            setTimeout(() => {
                selector._addDataValue('state', 'active')
                selector.classList.add('is-animate')
            }, 1500)
        }

        selector.querySelector('[data-lib-cookieconsent-approve]').addEventListener('click', () => {
            this.hide(['performance', 'marketing'])
        })

        selector.querySelector('[data-lib-cookieconsent-decline]').addEventListener('click', () => {
            this.hide([])
        })
    }

    hide(type) {
        LibCookieConsent.set(type)
        this.element.classList.remove('is-animate')

        setTimeout(() => {
            this.element._removeDataValue('state', 'active')
            this.element.remove()
        }, 500)
    }
});

application.register("part_form_cookieconsent", class extends Stimulus.Controller {
    connect() {
        const selector = this.element
        const type = localStorage.getItem('lib-cookieconsent')

        if (selector === null) {
            return
        }

        selector.classList.remove('is-animate')
        if (document.querySelector('.part_cookieconsent')) {
            document.querySelector('.part_cookieconsent').classList.remove('is-animate')
            document.querySelector('.part_cookieconsent')._removeDataValue('state', 'active')
        }

        if (type !== null) {
            selector.querySelectorAll('input:not([disabled])').forEach(input => input.checked = false)

            JSON.parse(type).forEach(type => {
                if (selector.querySelector(`input[value="${type}"]`) !== null) {
                    selector.querySelector(`input[value="${type}"]`).checked = true
                }
            })
        }

        selector.addEventListener('submit', e => {
            e.preventDefault()

            let type = []

            selector.querySelectorAll('input:not([disabled])').forEach(input => {
                input.checked && type.push(input.value)
            })

            LibCookieConsent.set(type)
            location.reload()
        })
    }
    disconnect() {
        if (document.querySelector('.part_cookieconsent')) {
            document.querySelector('.part_cookieconsent').classList.add('is-animate')
            document.querySelector('.part_cookieconsent')._addDataValue('state', 'active')
        }

    }
});
